module.exports = __webpack_public_path__ + "img/ningxia.2abdf149.png";